import React from 'react';

// Card for a single game. Used by the home page teaser and the games page.
const GameCard = ({ game, size = "default" }) => {
  const large = size === "large";
  // Color mapping for the card banner
  const getColorClass = (colorName) => {
    const colors = {
      indigo: "from-indigo-500 to-indigo-700",
      sky: "from-sky-400 to-sky-600",
      rose: "from-rose-400 to-rose-600",
      emerald: "from-emerald-400 to-emerald-600",
      amber: "from-amber-400 to-amber-600",
      violet: "from-violet-400 to-violet-600",
    };
    return colors[colorName] || "from-slate-400 to-slate-600";
  };

  return (
    <a
      href={game.path}
      target="_blank"
      rel="noopener noreferrer"
      data-umami-event="play-game"
      data-umami-event-game={game.slug}
      className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-100 transform hover:-translate-y-1 block"
    >
      <div className={`aspect-video w-full bg-gradient-to-br ${getColorClass(game.color)} flex items-center justify-center relative overflow-hidden`}>
        {game.thumbnail ? (
          <img
            src={game.thumbnail}
            alt={game.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <span className="text-6xl group-hover:scale-110 transition-transform duration-500" role="img" aria-hidden="true">
            {game.emoji}
          </span>
        )}
        <span className="absolute bottom-2 right-2 text-xs bg-white/80 px-2 py-1 rounded-full font-medium shadow-sm">
          Play
        </span>
      </div>
      <div className="p-5">
        <h3 className={`${large ? "text-2xl" : "text-xl"} font-bold text-slate-800 mb-2 group-hover:text-rose-600 transition-colors`}>
          {game.title}
        </h3>
        <p className={`text-slate-500 text-sm ${large ? "" : "line-clamp-2"}`}>
          {game.description}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {game.tags.map((tag, idx) => (
            <span key={idx} className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-md">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
};

export default GameCard;
